const KEY = "godo_zkteco_pairing_code";

export function stashZktecoPairingCode(code: string) {
  sessionStorage.setItem(KEY, code.trim());
}

export function takeZktecoPairingCode(): string | null {
  const v = sessionStorage.getItem(KEY)?.trim();
  if (!v) return null;
  sessionStorage.removeItem(KEY);
  return v;
}

export function peekZktecoPairingCode(): string | null {
  return sessionStorage.getItem(KEY)?.trim() || null;
}
